module.exports = __webpack_public_path__ + "fonts/firacode-regular.e9056fd.eot";